var r = "right-scroll-bar-position", a = "width-before-scroll-bar", l = "with-scroll-bars-hidden", e = "--removed-body-scroll-bar-size";
export {
  a as fullWidthClassName,
  l as noScrollbarsClassName,
  e as removedBarSizeVariable,
  r as zeroRightClassName
};
//# sourceMappingURL=index.es446.js.map
